import { useLocation, useNavigate } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import RedeemIcon from '@mui/icons-material/Redeem'
import BadgeIcon from '@mui/icons-material/Badge'
import NewspaperIcon from '@mui/icons-material/Newspaper'
import WorkIcon from '@mui/icons-material/Work'
import EmailIcon from '@mui/icons-material/Email'
import PeopleIcon from '@mui/icons-material/People'
import CustomButton from '../components/Button'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import BarChartIcon from '@mui/icons-material/BarChart'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import SchoolIcon from '@mui/icons-material/School'
import { isAdmin, isRootAdmin } from '../helpers/utils'
import { useContext, useEffect, useState } from 'react'
import { PageContext } from '../context/PageContext'

const userTabs: Tab[] = [
    {
        label: 'Inicio',
        route: '/home',
        icon: <HomeIcon />,
    },
    {
        label: 'Novedades',
        route: '/news',
        icon: <NewspaperIcon />,
    },
    {
        label: 'Comunidades',
        route: '/communities',
        icon: <PeopleIcon />,
    },
    {
        label: 'Mensajes',
        route: '/messages',
        icon: <EmailIcon />,
    },
    {
        label: 'Beneficios',
        route: '/benefits',
        icon: <RedeemIcon />,
    },
    {
        label: 'Credencial',
        route: '/credential',
        icon: <BadgeIcon />,
    },
    {
        label: 'Bolsa de trabajo',
        route: '/jobs',
        icon: <WorkIcon />,
    },
]

const adminTabs: Tab[] = [
    {
        label: 'Novedades',
        route: '/news',
        icon: <NewspaperIcon />,
    },
    {
        label: 'Bolsa de trabajo',
        route: '/jobs',
        icon: <WorkIcon />,
    },
    {
        label: 'Beneficios',
        route: '/benefits',
        icon: <RedeemIcon />,
    },
    {
        label: 'Publicaciones',
        route: '/posts',
        icon: <PendingActionsIcon />,
    },
    {
        label: 'Graduados',
        route: '/graduates',
        icon: <SchoolIcon />,
    },

    {
        label: 'Estadísticas',
        route: '/statistics',
        icon: <BarChartIcon />,
    },
]

export interface Tab {
    label: string
    route?: string
    icon: JSX.Element
    id?: number
}

const Sidebar = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const hiddenAt = [
        'login',
        'register',
        'recover-password',
        'recovery-code',
        'new-password',
        'activateUser',
        'activateLinkedinUser',
        'pending-user',
        'validate',
    ]
    const { showSidebar: show, setShowSidebar, smallScreen } = useContext(PageContext)

    const showSidebar = () => {
        return hiddenAt.every((path) => !pathname.includes(path))
    }

    const tabStyle = (route: string) =>
        pathname.split('/')[1] !== route.split('/')[1]
            ? 'bg-white text-primary'
            : 'bg-secondary text-white'

    const TabButton = ({ tab }: { tab: Tab }) => (
        <CustomButton
            key={tab.label}
            text={tab.label}
            onClick={() => {
                navigate(tab.route as string)
                if (smallScreen) setShowSidebar((prev) => !prev)
            }}
            className={`${smallScreen ? (show ? 'w-64' : 'hidden') : 'w-64'} h-10 my-1 justify-start shadow-[2px_2px_2px_0px_rgba(38,_44,_71,_0.1)] ${tabStyle(tab.route as string)}`}
            startIcon={tab.icon}
        />
    )

    return (
        <div className={`${smallScreen ? (show ? 'w-fit' : 'hidden') : 'w-fit'}`}>
            {showSidebar() && (
                <aside
                    className={`sticky top-16 left-0  pt-6 pb-4 h-full bg-light shadow-[1px_0px_16px_0px_rgba(31,_34,_50,_0.25)] flex flex-col justify-between ${
                        smallScreen ? (show ? 'w-fit px-4' : 'hidden') : 'w-fit px-4'
                    }`}
                >
                    <div className="flex flex-col">
                        {isRootAdmin() && (
                            <TabButton
                                tab={{
                                    label: 'Administradores',
                                    route: '/admins',
                                    icon: <AdminPanelSettingsIcon />,
                                }}
                            />
                        )}
                        {isAdmin() ? (
                            <>
                                {adminTabs.map((tab) => (
                                    <div key={tab.label}>
                                        <TabButton tab={tab} />
                                    </div>
                                ))}
                            </>
                        ) : (
                            <>
                                {userTabs.map((tab) => (
                                    <div key={tab.label}>
                                        <TabButton tab={tab} />
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </aside>
            )}
        </div>
    )
}

export default Sidebar
